import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { guid } from 'helpers/guid';

const IconBase = ({ children, color = '#fff', size = '1em', title, description, ...props }) => {
  const id = useMemo(() => guid(), []);
  const titleId = `icon-title-${id}`;
  const descriptionId = `icon-description-${id}`;
  return (
    <svg
      role="img"
      preserveAspectRatio="xMidYMid meet"
      fill={color}
      height={size}
      width={size}
      aria-labelledby={title ? titleId : undefined}
      aria-describedby={description ? descriptionId : undefined}
      {...props}>
      {title && <title id={titleId}>{title}</title>}
      {description && <desc id={descriptionId}>{description}</desc>}
      {children}
    </svg>
  );
};

IconBase.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  title: PropTypes.string,
  description: PropTypes.string
};

export default IconBase;
